export class ScrollSmoothTo{
	public static run(scrollPos: number): Promise<void> {
		return new Promise<void>(resolve => {
			let i = window.pageYOffset;
			let isDown = true;
			let shouldScroll = true;
			let stepSize = 20;
			if(scrollPos < i){
				isDown = false;
			}

			var int = setInterval(function(){
				window.scrollTo(0, i);
				let targetReached = false;
				if(isDown){
					if(i+stepSize > scrollPos){
						stepSize = scrollPos - i;
					}
					i += stepSize;
					targetReached = (i >= scrollPos);
				}else{
					if(i-stepSize < scrollPos){
						stepSize = (scrollPos - i) * (-1);
					}
					i-= stepSize;	
					targetReached = (i <= scrollPos);
				}
				if (targetReached)  {
					window.scrollTo(0, i);
					clearInterval(int);
					setTimeout(() => resolve())
				}
			}, 1);
		});
	}
}